import { throttle } from '@/services/helpers/throttle';

const events = ['mousemove', 'click', 'keydown', 'scroll', 'touchstart'];
const IDLE_TIMEOUT = 15 * 60 * 1000;

class IdleTracker {
  private idleListeners: Array<() => void> = [];
  private activeListeners: Array<() => void> = [];
  private idleTimer: NodeJS.Timeout | null = null;
  private isTrackerStarted = false;
  private isIdle = true; // Флаг состояния бездействия

  // Регистрация слушателей для состояния бездействия
  public registerIdleListener(listener: () => void) {
    if (!this.idleListeners.includes(listener)) {
      this.idleListeners.push(listener);
    }
  }

  // Регистрация слушателей для состояния активности
  public registerActiveListener(listener: () => void) {
    if (!this.activeListeners.includes(listener)) {
      this.activeListeners.push(listener);
    }
  }

  public removeIdleListener(listener: () => void) {
    this.idleListeners = this.idleListeners.filter((l) => l !== listener);
  }

  public removeActiveListener(listener: () => void) {
    this.activeListeners = this.activeListeners.filter((l) => l !== listener);
  }

  // Создание прослушивания событий на window
  public startTracker() {
    if (this.isTrackerStarted) return;
    this.isTrackerStarted = true;

    const throttledResetIdleTimer = throttle(
      this.resetIdleTimer.bind(this),
      500
    );
    events.forEach((event) => {
      window.addEventListener(event, throttledResetIdleTimer, {
        passive: true
      });
    });
    this.startTimer();
  }

  // Обновление таймера бездействия
  public resetIdleTimer() {
    if (this.isIdle) {
      // Если мы были в состоянии бездействия, то вызываем слушатели активности
      // и сбрасываем флаг бездействия
      this.isIdle = false;
      this.activeListeners.forEach((listener) => listener());
    }
    if (this.idleTimer) clearTimeout(this.idleTimer);
    this.startTimer();
  }

  public cleanup() {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
      this.idleTimer = null;
    }
    events.forEach((event) => {
      window.removeEventListener(event, this.resetIdleTimer);
    });
    this.idleListeners = [];
    this.isTrackerStarted = false;
    this.isIdle = false;
  }

  private startTimer() {
    this.idleTimer = setTimeout(() => {
      // Если таймер сработал, то мы находимся в состоянии бездействия
      // и вызываем слушатели бездействия
      this.isIdle = true;
      this.idleListeners.forEach((listener) => listener());
    }, IDLE_TIMEOUT);
  }
}

export const idleTracker = new IdleTracker();
